require('./social');
require('./cookie');
require('./lazyload');
require('./utilities');
require('./form');
require('./post');
require('./ads');
require('./archive');
require('./category-archive');
require('./article-archive');
require('../../vendor/star-rating-svg/star-rating-svg');



// WEBPACK FOOTER //
// ./src/js/app.js